import { IAPIErrorContent } from 'common/api/type-def';

import apiWrapper from '../../../common/api/api-wrapper';

const {
	REACT_APP_RECORD_MANAGER_SERVICE_URL,
	REACT_APP_FILE_UPLOAD_SERVICE_URL,
	REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL,
} = process.env;

export const cancelFileUpload = async (params: any) => {
	const resp = await apiWrapper.delete<any[]>(
		`${REACT_APP_RECORD_MANAGER_SERVICE_URL}/file-upload`,
		params,
	);
	return resp;
};

export const downloadFileTemplate = async (
	fileName: string,
	dataType: string,
) => {
	const url = `${REACT_APP_FILE_UPLOAD_SERVICE_URL}/download?fileName=${fileName}&dataType=${dataType}&fileType=template`;
	const resp = await apiWrapper.get<unknown, IAPIErrorContent>(url);
	return resp;
};

export const initiateProcessUpload = async (data: any) => {
	const resp = await apiWrapper.post<unknown, IAPIErrorContent>(
		`${REACT_APP_FILE_UPLOAD_SERVICE_URL}/process`,
		data,
	);
	return resp;
};
export const deleteUploadedFile = async (
	dataType: string,
	fileName: string,
) => {
	const url = `${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/file/delete?fileName=${fileName}&dataType=${dataType}`;
	const resp = await apiWrapper.delete<unknown, IAPIErrorContent>(url, {});
	return resp;
};

export const uploadRegParser = async (headers: any) => {
	const url = `${REACT_APP_FILE_UPLOAD_SERVICE_URL}/regulation/ingestion/parse`;
	const resp = await apiWrapper.post<string, IAPIErrorContent>(url, headers);
	return resp;
};
